export var SectorType;
(function (SectorType) {
    SectorType["ACCOMMODATION"] = "ACCOMMODATION";
    SectorType["SPA"] = "SPA";
    SectorType["RESTAURANT"] = "RESTAURANT";
    SectorType["OTHER"] = "OTHER";
    SectorType["WEEKLY_PLANNER"] = "WEEKLY_PLANNER";
})(SectorType || (SectorType = {}));
export var NotificationTrigger;
(function (NotificationTrigger) {
    NotificationTrigger["PENDING"] = "PENDING";
    NotificationTrigger["CONFIRMED"] = "CONFIRMED";
    NotificationTrigger["CANCELLED"] = "CANCELLED";
    NotificationTrigger["UPDATED"] = "UPDATED";
    NotificationTrigger["COMPLETED"] = "COMPLETED";
    NotificationTrigger["NO_SHOW"] = "NO_SHOW";
    NotificationTrigger["EXTERNAL_RECEIVED_NOT_CONFIRMED"] = "EXTERNAL_RECEIVED_NOT_CONFIRMED";
    NotificationTrigger["EXTERNAL_RECEIVED_CONFIRMED"] = "EXTERNAL_RECEIVED_CONFIRMED";
})(NotificationTrigger || (NotificationTrigger = {}));
